import { Component, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ICON } from '@core/util/icon';
import { ILocalBranch } from '@models/localBranch';
import { TrustAccount } from '@models/trustAccount';
import { Select } from '@ngxs/store';
import { LocalBranchesState } from '@state/business/localBranches/localBranches.state';
import { TrustAccountsState } from '@state/business/trustAccounts/trustAccounts.state';
import { Observable } from 'rxjs';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { AddEditLocalBranchComponent } from './add-edit-local-branch/add-edit-local-branch.component';

enum DrawerType {
	TRUST_ACCOUNT = 'trustAccount',
	LOCAL_BRANCH = 'localBranch',
}
@Component({
	selector: 'app-trust-accounts',
	templateUrl: './trust-accounts.component.html',
	standalone: false,
})
export class TrustAccountsComponent {
	@Select(TrustAccountsState.getAll) trustAccounts$: Observable<TrustAccount[]>;
	@Select(LocalBranchesState.getAll) localBranches$: Observable<ILocalBranch[]>;
	@ViewChild('drawer') drawer: MatDrawer;
	public id = null;
	public isFullyClosed = true;
	public ICON = ICON;
	public currentDrawer: DrawerType;
	public DrawerType = DrawerType;

	constructor(private drawerService: DrawerService) {}

	trackById(_index: number, item: TrustAccount | ILocalBranch): string {
		return item.id;
	}

	edit(drawerType: DrawerType, id: string) {
		this.currentDrawer = drawerType;
		this.id = id;
		if (drawerType === DrawerType.LOCAL_BRANCH) {
			this.drawerService.openDrawer(AddEditLocalBranchComponent, {
				title: 'Add Local Branch',
				data: {
					localBranchId: id,
				},
				size: 'sm',
			});
		} else {
			this.openDrawer();
		}
	}

	closeDrawer() {
		this.drawer.close();
		this.id = null;
		setTimeout(() => {
			this.isFullyClosed = true;
		}, 300);
	}

	openDrawer() {
		this.drawer.open();
		this.isFullyClosed = false;
	}

	public create(drawerType: DrawerType) {
		this.edit(drawerType, null);
	}
}
